// ── BB BLOG: THE ROUND ──

function initBlog() {

  // ── UNIFIED FILTER FUNCTION ──
  function applyFilter(filterValue) {

    // Show / hide cards
    let visible = 0;
    document.querySelectorAll('.bbl-card').forEach(function (card) {
      const match = filterValue === 'all' || card.getAttribute('data-cat') === filterValue;
      card.style.display = match ? '' : 'none';
      if (match) visible++;
    });

    // Sync post count label
    const countEl = document.querySelector('.bbl-grid-count');
    if (countEl) {
      countEl.textContent = visible + (visible === 1 ? ' Post' : ' Posts');
    }

    // Sync active state on filter buttons
    document.querySelectorAll('.bbl-filter-btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-filter') === filterValue);
    });

    // Sync active state on topic pills
    document.querySelectorAll('.bbl-topic-pill').forEach(function (pill) {
      pill.classList.toggle('active', pill.getAttribute('data-filter') === filterValue);
    });
  }

  // ── WIRE FILTER BUTTONS ──
  document.querySelectorAll('.bbl-filter-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      applyFilter(this.getAttribute('data-filter') || 'all');
    });
  });

  // ── WIRE TOPIC PILLS ──
  document.querySelectorAll('.bbl-topic-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      const f = this.getAttribute('data-filter');
      if (f) {
        applyFilter(f);
      } else {
        // pill has no filter mapping — just toggle visually
        document.querySelectorAll('.bbl-topic-pill').forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  // ── SCROLL REVEAL ──
  const obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.06 });
  document.querySelectorAll('.bbl-reveal, .bbl-card').forEach(function (el) { obs.observe(el); });
}

// Works whether script runs before or after DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlog);
} else {
  initBlog();
}
